import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { DefaultButton, PrimaryButton } from '@fluentui/react';
import { edmCampaign } from '@bingads-webui/edm-campaign';
import config from '@bingads-webui-component-legacy/config/index';
import { Toggle } from '@fluentui/react/lib/Toggle';

export function WebInsightsEditor(props) {
  const {
    i18n, scope, onCancel, isInsightOn, onSave,
  } = props;
  const { tagId } = scope.values;
  const [isToggleOn, setIsToggleOn] = useState(isInsightOn);

  const triggerDocumentEvent = useCallback(() => {
    const event = new CustomEvent('toggleWebInsight', { detail: { tagId, isToggleOn } });
    document.dispatchEvent(event);
  }, [isToggleOn, tagId]);

  const onToggleClick = (event, checked) => {
    setIsToggleOn(checked);
  };

  const onSaveClick = useCallback(() => {
    const value = {
      Id: tagId,
      IsWebInsightsEnabled: isToggleOn,
    };
    const { Id: cid } = config.get('CurrentCustomer');
    const { Id: aid, AdvertiserCustomerID: acid } = config.get('CurrentAccount');
    const isAgencyScenario = acid && (acid !== cid) && scope.values.aid;
    const edmHolder = isAgencyScenario ? edmCampaign.Customers.$withKey(acid).Accounts.$withKey(aid) : edmCampaign.Customers.$withKey(cid);

    edmHolder
      .Tags['Default.UpdateTagsWebInsightsSetting']
      .$makeCall({ payload: { Tags: [value] } })
      .toPromise().then(() => {
        onSave(isToggleOn);
        triggerDocumentEvent();
      });
  }, [isToggleOn, onSave, scope, tagId, triggerDocumentEvent]);

  const onCancelClick = useCallback(() => {
    onCancel();
  }, [onCancel]);

  return (
    <div>
      <div>
        {i18n.getString(_TL_('Click the toggle to enable or disable UET Insights. You can edit this setting at anytime.'))}
      </div>
      <a
        href="https://help.ads.microsoft.com/#apex/ads/en/60177/-1"
        target="_blank"
        rel="noopener noreferrer"
        aria-label={i18n.getString(_TL_('Learn More'))}
      >
        {i18n.getString(_TL_('Learn More'))}
      </a><br /><br />
      <Toggle
        onText={i18n.getString(_TL_('UET Insights Enabled'))}
        offText={i18n.getString(_TL_('UET Insights Disabled'))}
        onChange={onToggleClick}
        checked={isToggleOn}
      />
      <div style={{ display: 'flex', gap: '10px' }}>
        <PrimaryButton text={i18n.getString(_TL_('Save'))} onClick={onSaveClick} />
        <DefaultButton text={i18n.getString(_TL_('Cancel'))} onClick={onCancelClick} />
      </div>
    </div>
  );
}

WebInsightsEditor.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  scope: PropTypes.shape({
    aid: PropTypes.number,
    values: PropTypes.shape({
      cid: PropTypes.number,
      uid: PropTypes.number,
      aid: PropTypes.number,
      tagId: PropTypes.number,
    }).isRequired,
  }).isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isInsightOn: PropTypes.bool.isRequired,
  tag: PropTypes.shape({
    Id: PropTypes.string.isRequired,
  }).isRequired,
};
